import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import UnitListItem from '../unit-list-item/unit-list-item.component';
import useTranslation from 'Hooks/useTranslation';

const UnitList = ({ units, setValues, selectedChannels, disabledChannels, search, selectedCsvChannels, setInitialValues }) => {
    const translation = useTranslation();
    const [globalSelectAll, setGlobalSelectAll] = useState(false);
    const [selectedChannelCount, setSelectedChannelCount] = useState(0);
    const [totalChannelsCount, setTotalChannelsCount] = useState(0);

    useEffect(() => {
        const total = units.reduce((acc, unit) => {
            if (unit.isEnabled === false) return acc;
            return acc + unit.channels.length;
        }, 0);
        setTotalChannelsCount(total);
    }, [units]);

    useEffect(() => {
        setSelectedChannelCount(selectedChannels.length);
    }, [selectedChannels]);

    const handleGlobalSelectAllChange = (e) => {
        const checked = e.target.checked;
        setGlobalSelectAll(checked);

        const updatedChannels = units.flatMap((unit) => {
            if (unit.isEnabled === false) return [];
            return unit.channels
                .filter(
                    (channel) =>
                        !selectedChannels.some(
                            (selectedChannel) => selectedChannel.id === channel.id
                        )
                )
                .map((channel) => ({ ...channel }));
        });

        setInitialValues(prevValues => checked ? [...prevValues, ...updatedChannels] : []);
        setValues(prevValues => checked ? [...prevValues, ...updatedChannels] : []);
    };

    const isPartlySelected = !globalSelectAll && selectedChannelCount > 0 && selectedChannelCount < totalChannelsCount;

    return (
        <div className="channelTable">
            <div className="channelTableHead">
                <span className="channelTableHeadTitle">{translation.dashboardChannelsLabel}</span>
                <span className="channelTableCount">{selectedChannelCount} / {totalChannelsCount}</span>
                <FormControlLabel
                    className="channelTableSelectAll"
                    control={
                        <Checkbox
                            size="small"
                            color="default"
                            checked={globalSelectAll}
                            indeterminate={isPartlySelected}
                            onChange={handleGlobalSelectAllChange}
                            id="unitListBtn-selectAll"
                        />
                    }
                    label={translation.selectAllLabel || 'Select all'}
                    labelPlacement="start"
                />
            </div>
            <div className="channelTableBody">
                {units !== null && units.map((unit, index) => (
                    <UnitListItem
                        key={unit.id}
                        unit={unit}
                        index={index}
                        search={search}
                        selectedChannels={selectedChannels}
                        selectedCsvChannels={selectedCsvChannels}
                        disabledChannels={disabledChannels}
                        defaultShow={units.length === 1}
                        setValues={setValues}
                        globalSelectAll={globalSelectAll}
                        setInitialValues={setInitialValues}
                    />
                ))}
            </div>
        </div>
    );
};

export default UnitList;
